import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {Customer} from '../../model/Entities/Customer';
import {Product} from '../../model/Entities/Product';
import {FormControl, Validators} from '@angular/forms';
import {numberValidator} from '../../validators/number.validator';
import {intValidator} from '../../validators/int.validator';
import {Contract} from '../../model/Entities/Contract';
import {CustomerService} from '../../services/customer.service';
import {CustomerContactPersonService} from '../../services/customer-contact-person.service';
import {Filter} from '../../model/Helpers/Filter';
import {CustomerContactPerson} from '../../model/Entities/CustomerContactPerson';
import {MailService} from '../../services/mail.service';
import {Email} from '../../model/Entities/Email';
import {SnackService} from '../../services/snack.service';
import {ConfigService} from '../../services/config.service';
import {UserService} from '../../services/user.service';
import {ContractEventService} from '../../services/event.service';
import {ContractEvent} from '../../model/Entities/ContractEvent';
import {PrintService} from '../../services/print.service';

@Component({
    selector: 'customers-stats-dialog',
    templateUrl: './customers-stats.dialog.component.html',
    styleUrls: ['./customers-stats.dialog.component.scss']
})
export class CustomersStatsDialogComponent {

    public from = new Date();
    public to = new Date();

    dateFromFC = new FormControl('', [
        Validators.required,
    ]);

    dateToFC = new FormControl('', [
        Validators.required,
    ]);

    constructor(public dialog: MatDialogRef<CustomersStatsDialogComponent>,
                public printService: PrintService,
                @Inject(MAT_DIALOG_DATA) public data: any) {

        this.from.setHours(0, 0, 0, 0);
        this.to.setHours(23, 59, 59, 999);

        this.from.setMonth(0, 1);
        this.to.setMonth(11, 31);
    }

    checkValidity(): boolean {
        return this.dateFromFC.valid && this.dateToFC.valid;
    }

    show(): void {
        const url = this.printService.getCustomersStatsPrintUrl([
            new Filter('from', this.from.toISOString()),
            new Filter('to', this.to.toISOString())
        ]);
        window.open(url, '_blank');
        this.dialog.close();
    }
}



// WEBPACK FOOTER //
// /app/src/CustomersModule/CustomersStatsDialogComponent/customers-stats.dialog.component.ts